export const USEFUL_DOCS_SEEN = 'useful-documents:seen';
export const USEFUL_DOCS_CHANGED = 'useful-documents:changed';
export const USEFUL_DOCS_STORAGE = 'useful-documents-revision';

export function publishUsefulDocsChange(userId, count) {
    const detail = { userId, count };
    window.dispatchEvent(new CustomEvent(Number.isFinite(count) ? USEFUL_DOCS_SEEN : USEFUL_DOCS_CHANGED, { detail }));
    try { localStorage.setItem(USEFUL_DOCS_STORAGE, JSON.stringify({ ...detail, at: Date.now(), nonce: Math.random() })); } catch { /* Focus/polling restent disponibles. */ }
}